
export const getErrorMessage = (error) => {
    return messages[error.failedValidator.name]?.(error.failedValidator) ?? error.failedValidator.name;
};

const messages = {
    "required": () => "Required",
    "isNumber": () => `Needs to be a number`,
    "isInteger": () => `Needs to be an integer`,
    "min": ({min}) => `Minimum value is ${min}`,
    "max": ({max}) => `Maximum value is ${max}`,
};